import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { REGISTER_STORAGE_URL } from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

import { ArrowIcon } from './icons';

export default function StorageConnection() {
	const t = useTranslation(TranslationNamespace.Marketing).t;

	return (
		<section className="storage-section6">
			<div className="containerWarehouse">
				<div className="storage-section6__inner">
					<h2 className="section-title">
						{t('storage.storage-connection.connect-in-just-a-few-minutes')}
					</h2>

					<div className="storage-section6__steps-container">
						<div className="storage-section6__steps-container_tile">
							<div className="storage-section6__steps-container_tile_content">
								<span className="storage-section6__steps-container_tile_number">1</span>

								<h2>{t('storage.storage-connection.provide-information-about-the-company')}</h2>
								<div className="block text-justify">
									<span className="storage-section6steps-container_tile_description">
										{t(
											'storage.storage-connection.fill-in-the-legal-details-of-your-company-attach-documents',
										)}
										.
									</span>
								</div>
							</div>

							<div className="mt-auto h-[13rem] shrink-0 flex justify-end items-center">
								<ArrowIcon />
							</div>
						</div>

						<div className="storage-section6__steps-container_tile">
							<div className="storage-section6__steps-container_tile_content">
								<span className="storage-section6__steps-container_tile_number">2</span>

								<h2>{t('storage.storage-connection.specify-warehouse-information')}</h2>
								<div className="block text-justify">
									<span className="storage-section6steps-container_tile_description text-justify">
										{t(
											'storage.storage-connection.fill-in-information-about-the-number-and-volume-of-your-chambers-tempera',
										)}
										.
									</span>
								</div>
							</div>

							<div className="mt-auto h-[13rem] shrink-0 flex justify-end items-center">
								<ArrowIcon />
							</div>
						</div>

						<div className="storage-section6__steps-container_tile">
							<div className="storage-section6__steps-container_tile_content">
								<span className="storage-section6__steps-container_tile_number text-justify">
									3
								</span>

								<h2>{t('storage.storage-connection.start-taking-applications')}</h2>
								<div className="block text-justify">
									<span className="storage-section6steps-container_tile_description">
										{t(
											'storage.storage-connection.receive-storage-requests-from-fish-companies-from-all-over-russia-and-in',
										)}
										.
									</span>
								</div>
							</div>

							<div className="mt-auto h-[13rem] shrink-0 flex items-center m-t-auto">
								<Button type="primary" block size="large" href={REGISTER_STORAGE_URL}>
									{t('storage.storage-connection.register-a-warehouse')}
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
